import { jsx as m } from "react/jsx-runtime";
import f from "styled-components";
import "@fcamna/shared-component-foundations";
import "react";
import { u as y } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { u as T, C as l } from "./useChartOptions-336145ca.mjs";
const L = ({
  chartLibElement: n,
  xAxis: u,
  yAxis: C,
  series: a,
  labelFormatter: $,
  legend: o,
  gridType: d = "both",
  hideTooltip: P,
  height: i,
  width: p
}) => {
  const g = y({ label: "Scatter Plot Chart" }), { options: r, customStyles: v } = T({
    type: l.SCATTER,
    xAxis: u,
    yAxis: C,
    series: a,
    labelFormatter: $,
    legend: o,
    isCategorical: !0,
    gridType: d,
    hideLabel: !0,
    hideTooltip: P
  }), e = v({ type: l.SCATTER }), S = f.div`
    ${e.tooltipStyles};
    ${e.gridStyles};
    ${(t) => {
    var c, h, s;
    return e == null ? void 0 : e.legendStyles(
      (c = r == null ? void 0 : r.legend) == null ? void 0 : c.horizontalAlign,
      (h = r == null ? void 0 : r.legend) == null ? void 0 : h.orientation,
      (s = r == null ? void 0 : r.legend) == null ? void 0 : s.position,
      t.$vertical
    );
  }}
    ${e == null ? void 0 : e.legendStyles((t) => t.$vertical)};
    height: ${(t) => t.theme.components.scatterPlotChart.Wrapper.height};
    width: ${(t) => t.theme.components.scatterPlotChart.Wrapper.width};
    min-height: ${(t) => t.theme.components.scatterPlotChart.Wrapper.minHeight};
    overflow-x: ${(t) => t.theme.components.scatterPlotChart.Wrapper.overflowX};
  `;
  return /* @__PURE__ */ m(
    S,
    {
      "data-testid": "scatterPlot-wrapper",
      $vertical: (o == null ? void 0 : o.orientation) === "vertical",
      ...g,
      children: /* @__PURE__ */ m(
        n,
        {
          type: "scatter",
          width: p ? `${p}px` : "100%",
          options: r,
          series: a,
          height: i || "100%"
        }
      )
    }
  );
};
export {
  L as ScatterPlotChart
};
